import { initLoadMoreList } from "../shared/load-more-list";

document.addEventListener("DOMContentLoaded", function() {
    if (typeof engeto_loadmore_news_params !== 'undefined') {
        initLoadMoreList({
            buttonSelector: ".news-list-load-more",
            containerSelector: ".news-list-container .posts",
            action: "loadmore_news",
            params: engeto_loadmore_news_params
        });
    }
});